<template>

    <div>

        <div class="error merror error-pill d-flex justify-content-start align-items-center">

            {{ $t(`errors.${message}`) }}

        </div>

        <audio class="d-none" ref="audio" autoplay="false" controls>
            <source src="/audio/error.mp3" />
        </audio>

    </div>


</template>

<script>

    export default {

        props: ['message','id'],

        data () {

            return {

                out: null,
                milisecondsOut: 15000

            }

        },

        methods: {

            removeError() {

                this.$store.commit('Errors/REMOVE_ERROR', this.id)

            },

            audioError() {

                this.$refs.audio.play()

            }

        },

        mounted() {

            this.$nextTick(() => {

                this.audioError()
                this.out = setTimeout(() => this.removeError(), this.milisecondsOut)

            })

        }
        
    }

</script>

<style lang="scss"></style>